import { combineReducers, createReducer, on } from '@ngrx/store';
import { Status, type AsyncState } from '@essent/common';
import { FehApiActions } from '@feh/shared-api';

import { type SolarPanelsWizardFormValues } from './form-ids';
import { solarPanelsWizardFormSubmitAction } from './solar-panels-wizard.actions';
import {
  continueFlowFromSolarPanelsWizardAction,
  navigateToHouseIsUnsuitablePageAction,
} from '../solar-panels-funnel/solar-panels-funnel.actions';

export const solarPanelsWizardKey = 'solarPanelsWizard';

export interface SolarPanelsWizardState {
  submitState: AsyncState<undefined>;
  formValues: SolarPanelsWizardFormValues | undefined;
}

const formValueReducer = createReducer<SolarPanelsWizardState['formValues']>(
  undefined,
  on(solarPanelsWizardFormSubmitAction, (_, { formValues }) => formValues)
);

const submitStateReducer = createReducer<SolarPanelsWizardState['submitState']>(
  {
    status: Status.IDLE,
  },
  on(solarPanelsWizardFormSubmitAction, () => ({
    status: Status.PENDING,
  })),
  on(continueFlowFromSolarPanelsWizardAction, () => ({
    status: Status.IDLE,
  })),
  on(navigateToHouseIsUnsuitablePageAction, () => ({
    status: Status.IDLE,
  })),
  on(FehApiActions.getAddressinfoV1.errorAction, () => ({
    status: Status.ERROR,
  }))
);

export const solarPanelsWizardReducer = combineReducers({
  submitState: submitStateReducer,
  formValues: formValueReducer,
});
